import { render, staticRenderFns } from "./mergeStudentModal.vue?vue&type=template&id=e5368462&"
import script from "./mergeStudentModal.vue?vue&type=script&lang=js&"
export * from "./mergeStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./mergeStudentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports